import Clearbit from '@clearkit/icons/services/Clearbit';
import Facebook from '@clearkit/icons/services/Facebook';
import G2 from '@clearkit/icons/services/G2';
import GoogleAnalytics from '@clearkit/icons/services/GoogleAnalytics';
import Hubspot from '@clearkit/icons/services/Hubspot';
import Javascript from '@clearkit/icons/services/Javascript';
import Marketo from '@clearkit/icons/services/Marketo';
import Salesforce from '@clearkit/icons/services/Salesforce';
import Segment from '@clearkit/icons/services/Segment';
import Slack from '@clearkit/icons/services/Slack';

const logos = {
  clearbit: Clearbit,
  facebook: Facebook,
  google: GoogleAnalytics,
  marketo: Marketo,
  hubspot: Hubspot,
  javascript: Javascript,
  salesforce: Salesforce,
  salesforcesandbox: Salesforce,
  pardot: Salesforce,
  segment: Segment,
  slack: Slack,
  g2: G2,
};

export default function Logo({ type, ...props }) {
  const Component = logos[type];

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
}

Logo.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
};
